module.exports = __webpack_public_path__ + "static/media/ic_dialog_error.14fd6633.svg";